"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CommonCard = _interopRequireDefault(require("./CommonCard"));
/* eslint react/no-array-index-key: "off" */


var ImageContent = _botframeworkWebchatComponent.Components.ImageContent,
    VideoContent = _botframeworkWebchatComponent.Components.VideoContent;
var useStyleSet = _botframeworkWebchatComponent.hooks.useStyleSet;

var AnimationCardAttachment = function AnimationCardAttachment(_ref) {
  var attachment = _ref.attachment,
      _ref$attachment = _ref.attachment;
  _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
  var _ref$attachment$conte = _ref$attachment.content.media,
      media = _ref$attachment$conte === void 0 ? [] : _ref$attachment$conte;

  var _useStyleSet = useStyleSet(),
      _useStyleSet2 = (0, _slicedToArray2.default)(_useStyleSet, 1),
      animationCardAttachmentStyleSet = _useStyleSet2[0].animationCardAttachment;

  return _react.default.createElement("div", {
    className: animationCardAttachmentStyleSet
  }, _react.default.createElement("ul", {
    className: "media-list"
  }, media.map(function (_ref2, index) {
    var _ref2$profile = _ref2.profile,
        profile = _ref2$profile === void 0 ? '' : _ref2$profile,
        url = _ref2.url;
    return (// Because of differences in browser implementations, aria-label=" " is used to make the screen reader not repeat the same text multiple times in Chrome v75 and Edge 44
      _react.default.createElement("li", {
        "aria-label": " ",
        key: index
      }, /\.gif$/i.test(url) ? _react.default.createElement(ImageContent, {
        alt: profile,
        src: url
      }) : _react.default.createElement(VideoContent, {
        alt: profile,
        src: url
      }))
    );
  })), _react.default.createElement(_CommonCard.default, {
    attachment: attachment
  }));
};

AnimationCardAttachment.propTypes = {
  attachment: _propTypes.default.shape({
    content: _propTypes.default.shape({
      media: _propTypes.default.arrayOf(_propTypes.default.shape({
        profile: _propTypes.default.string,
        url: _propTypes.default.string.isRequired
      })).isRequired
    }).isRequired
  }).isRequired
};
var _default = AnimationCardAttachment;
exports.default = _default;